import { render, staticRenderFns } from "./EditImage.vue?vue&type=template&id=90c41efe&scoped=true&"
import script from "./EditImage.vue?vue&type=script&lang=js&"
export * from "./EditImage.vue?vue&type=script&lang=js&"
import style0 from "./EditImage.vue?vue&type=style&index=0&id=90c41efe&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c41efe",
  null
  
)

export default component.exports